import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ApiConnectionService } from 'src/app/services/core/api-connection.service';

@Component({
  selector: 'app-modal-portfolio-feedback',
  templateUrl: './modal-portfolio-feedback.component.html',
  styleUrls: ['./modal-portfolio-feedback.component.scss']
})
export class ModalPortfolioFeedbackComponent implements OnInit {

  @Input() public portfolioId: any = '';

  loading = true;

  portfolioData: any = {
    "item": []
  };

  formatDate(datetimeStr) {
    const months = ["januari", "februari", "maart", "april", "mei", "juni",
      "juli", "augustus", "september", "oktober", "november", "december"];

    const dateObj = new Date(datetimeStr);

    const day = dateObj.getDate();
    const monthIndex = dateObj.getMonth(); 
    const year = dateObj.getFullYear();

    const formattedDate = `${day} ${months[monthIndex]} ${year}`;

    return formattedDate;
  }

  constructor(public activeModal: NgbActiveModal, public apiService: ApiConnectionService) { }

  formatDutchDate(timestamp) {
    const monthsOfYear = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];

    const inputDate: any = new Date(timestamp);
    const currentDate: any = new Date();

    const diffTime = currentDate - inputDate;
    const oneMinute = 60 * 1000;
    const oneHour = 60 * oneMinute;
    const oneDay = 24 * oneHour;
    const diffMinutes = Math.floor(diffTime / oneMinute);
    const diffHours = Math.floor(diffTime / oneHour);
    const diffDays = Math.floor(diffTime / oneDay);

    if (diffTime < 0) {
      throw new Error("Timestamp is in the future");
    }

    if (diffDays < 1) {
      if (diffMinutes < 1) {
        return 'Zojuist';
      } else if (diffHours < 1) {
        if(diffMinutes == 1) {
          return `${diffMinutes} minuut geleden`;
        } else {
          return `${diffMinutes} minuten geleden`;
        }
      } else {
        return `${diffHours} uur geleden`;
      }
    } else if (diffDays < 7) {
      if(diffDays == 1) {
        return `${diffDays} dag geleden`;
      } else {
        return `${diffDays} dagen geleden`;
      }
    } else if (diffDays === 7) {
      return '1 week geleden';
    } else {
      const day = inputDate.getDate();
      const month = monthsOfYear[inputDate.getMonth()];
      const year = inputDate.getFullYear();

      return `${day} ${month}, ${year}`;
    }
  }

  ngOnInit(): void {
    let self = this;
    this.apiService.read("users/portfolio/" + this.portfolioId).then((data) => {
      this.portfolioData = data;
      this.loading = false;
      self.setRead();
    });
  }

  setRead () 
  {
    console.log('x');
    this.apiService.read("users/portfolioReadAll/" + this.portfolioId).then((data) => {
    });
  }

  getReflectionFiles() {
    return (this.portfolioData.files[Object.keys(this.portfolioData.files)[0]].files).reverse();
  }

  close() {
    this.activeModal.close(false);
  }
}
